import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Modal } from 'app/design/primitives/modal';
import { Text } from 'app/design/primitives/text';
import { createTheme as createDSTheme } from 'app/shopify';

const theme = createDSTheme();

interface NothingSelectedErrorModalProps {
  buttonLabel: string;
  message: string;
  onClose: () => void;
  open: boolean;
  title: string;
}

export function NothingSelectedErrorModal({
  buttonLabel,
  message,
  onClose,
  open,
  title,
}: NothingSelectedErrorModalProps) {
  return (
    <Modal onClose={onClose} open={open} transparent>
      <Modal.Card>
        <Modal.Title>
          <Text fontSize={20} fontWeight="bold" variant="bodyBase">
            {title}
          </Text>
        </Modal.Title>

        <Column style={{ marginHorizontal: theme.spacing['spacing.general.x8'] }}>
          <Text fontSize={16} textAlign="center">
            {message}
          </Text>
        </Column>

        <Button onPress={onClose} style={{ marginHorizontal: theme.spacing['spacing.general.x5'] }} variant="primary">
          {buttonLabel}
        </Button>
      </Modal.Card>
    </Modal>
  );
}
